import { render, staticRenderFns } from "./KnowledgeQuestion.vue?vue&type=template&id=1d77a52b"
import script from "./KnowledgeQuestion.vue?vue&type=script&lang=js"
export * from "./KnowledgeQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports